import { render } from "./spiner.vue?vue&type=template&id=3b3acbe8"
const script = {}

import "./spiner.vue?vue&type=style&index=0&id=3b3acbe8&lang=css"

import exportComponent from "C:\\Users\\gaglo\\OneDrive\\Bureau\\top_chronique\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__